'use client'

import { CustomButton } from '@/components'
import MainButton from '@/components/buttons/MainButton'
import ImageSlider from '@/components/ImageSlider'
import LogoTicker from '@/components/LogoTicker'
import { Modal } from '@/components/Modal'
import QRCodeGeneratorModal from '@/components/QRCodeGeneratorModal'
import Typography from '@/components/typography/Typography'
import useAppsFlyer from '@/hooks/useAppsFlyer'
import { useT } from '@/phrase/hooks/useT'
import clsx from 'clsx'
import Image from 'next/image'
import { useState } from 'react'

const LOGO_TICKER_IMAGES = [
  '/images/home/logos/001.png',
  '/images/home/logos/002.png',
  '/images/home/logos/003.png',
  '/images/home/logos/004.png',
  '/images/home/logos/005.png',
  '/images/home/logos/006.png',
  '/images/home/logos/007.png',
  '/images/home/logos/008.png',
]

const Gradient = () => {
  return (
    <div className="absolute inset-0 overflow-hidden ">
      <div
        className="absolute"
        style={{
          top: '40%',
          left: '55%',
          width: '40%',
          height: '10%',
          transform: 'translate(-50%, -50%) rotate(110deg)',
          borderRadius: '50%',
          background:
            'linear-gradient(117deg, rgba(24,75,255,0.2) 0%, rgba(23,74,255,0.3) 100%)',
          filter: 'blur(150px)',
          opacity: 0.3,
        }}
      />
    </div>
  )
}

type Slide = { src: string; alt?: string }

const imagesData: Slide[] = [
  {
    src: 'https://public.freedom.world/landing_page/modal/Community.avif',
    alt: '',
  },
  {
    src: 'https://public.freedom.world/landing_page/modal/Missions.avif',
    alt: '',
  },
  {
    src: 'https://public.freedom.world/landing_page/modal/Rewards.avif',
    alt: '',
  },
]

const Hiro = () => {
  const t = useT()
  const [open, setOpen] = useState(false)
  const { generatedUrl } = useAppsFlyer()

  return (
    <div
      className="relative md:min-h-screen  xs:px-4  px-1 md:pb-10 pb-20 text-white w-full flex flex-col items-center gap-6 md:gap-12 lg:gap-24 justify-center "
      style={{
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        // width: '100vw !important',
      }}
    >
      <Image
        src="/images/home/hiro/bg.webp"
        alt="Background"
        fill
        priority
        fetchPriority="high"
        className="object-cover z-0"
      />
      <Gradient />

      <div className="flex flex-col justify-center items-center gap-4 w-full z-1  ">
        <div
          className="w-full m-auto flex flex-col items-center justify-center md:pt-30 pt-12.5"
          style={{
            background: 'linear-gradient(0deg,#02021000 0%, #020210 10%)',
          }}
        >
          <Typography
            variant="headersH1"
            type="h2"
            weight="900"
            className="w-fit text-white uppercase text-[30px] md:text-[40px]  text-center font-black"
          >
            {t('hero_your_business_your_world_title')}
          </Typography>

          <Typography
            variant="headersDispalyLarge"
            type="h1"
            weight="900"
            className={clsx(
              'rounded-full w-fit text-green-main uppercase  text-[30px] md:text-[60px]  text-center font-black',
            )}
          >
            {t('hero_your_business_your_world_title2')}
          </Typography>
        </div>

        <Typography
          variant="bodySmall"
          type="h5"
          weight="400"
          className={clsx(' text-center px-4 text-light-gray4')}
        >
          {t('hero_your_business_your_world_desc')}
        </Typography>
        <MainButton
          label={t('footer_getstarted_title')}
          icon="/svgs/up-right-arrow.svg"
          target="_blank"
          onClick={() => {
            if (window.innerWidth < 768) {
              window.open(
                'https://apps.apple.com/my/app/freedom-world-social-chat/id1606936073',
                '_blank',
              )
            } else {
              setOpen(true)
            }
          }}
          className="bg-blue-main cursor-pointer z-1000"
          noBorder
        />

        {/* <CustomButton
          title={t('footer_getstarted_title')}
          typographyVariant="bodyLarge"
          circleColor="bg-blue-main"
          fontSize="text-"
          // onClickUrl="https://console.freedom.world/"
          className="uppercase mt-3"
          onClickFunc={() => setOpen(true)}
        /> */}

        <div className="md:-mt-15  relative mx-auto w-full max-w-294.75 aspect-1179/600">
          <Image
            alt="Descriptive Alt"
            src="/images/home/hero/iPad.avif"
            width={1179}
            height={773}
            sizes="(max-width: 768px) 100vw, 1179px"
            className="absolute bottom-0 fade-in"
            style={{ width: '100%', height: 'auto', animationDelay: '0.6s' }}
            priority
            fetchPriority="high"
            loading="eager"
            placeholder="blur"
            blurDataURL="/images/home/hiro/image001-blur.jpg"
          />
          <Image
            alt=""
            src="/images/home/hero/5StarCoffee.webp"
            width={213}
            height={139}
            className="h-auto absolute fade-in xxl:left-[4.6%] left-[14.6%] xxl:bottom-[48.5%] bottom-[75.5%]"
            style={{
              // bottom: '33.5%',
              // left: '5.697%',
              width: '22.17%',
              animationDelay: '0.9s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/FDS1.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in xxl:left-[-5%] left-[12%] xxl:bottom-[23%] bottom-[53%]"
            style={{
              // bottom: '23%',
              // left: '-5%',
              width: '9.25%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Shard1.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in md:left-[12%] left-[12%] md:bottom-[13.6%] bottom-[24%]"
            style={{
              // bottom: '13.667%',
              // left: '11.969%',
              width: '4.75%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Soulgazer1.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in"
            style={{
              bottom: '15.667%',
              left: '18.666%',
              width: '5.68%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Pin_Restaurant.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in"
            style={{
              bottom: '30.667%',
              left: '26.36%',
              width: '6.87%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Ghajar.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in md:left-[29%] left-[29%] md:bottom-[16.1%] bottom-[11%]"
            style={{
              // bottom: '16.167%',
              // left: '29.21%',
              width: '5.43%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/FDW Logo.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in"
            style={{
              bottom: '36.333%',
              left: '38.33%',
              width: '24.43%',
              animationDelay: '0.6s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Soulgazer1.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in"
            style={{
              bottom: '22.5%',
              left: '62.52%',
              width: '3.985%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Shard2.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in md:left-[62%] left-[58%] md:bottom-[11.5%] bottom-[10%]"
            style={{
              // bottom: '11.5%',
              // left: '62%',
              width: '4.75%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Ghost.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in"
            style={{
              bottom: '14%',
              left: '70.81%',
              width: '5.86%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Pin_Shop.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in md:left-[78.3%] left-[75%] md:bottom-[12.5%] bottom-[24%]"
            style={{
              // bottom: '12.5%',
              // left: '78.3%',
              width: '7.64%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/Monthly.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in md:left-[73.66%] left-[66%] md:bottom-[34.33%] bottom-[54%]"
            style={{
              // bottom: '34.333%',
              // left: '73.66%',
              width: '23.91%',
              animationDelay: '0.9s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
          <Image
            alt=""
            src="/images/home/hero/FDS2.avif"
            width={289}
            height={400}
            className="h-auto absolute fade-in xxl:right-[-6.12%] right-[12%] xxl:bottom-[21%] bottom-[83%] "
            style={{
              width: '10.18%',
              animationDelay: '1.2s',
            }}
            priority
            fetchPriority="high"
            loading="eager"
          />
        </div>
      </div>

      <LogoTicker
        logos={LOGO_TICKER_IMAGES}
        height={64}
        gap={90}
        speed={70}
        direction="left"
        pauseOnHover
      />
      {/* <div className="bg-blue-400 w-full">sdskhfkshkshj</div> */}
      <div className=" absolute bottom-0 left-0 bg-red-500 w-screen!">
        {/* <div className="relative  bg-transparent mx-auto w-screen! "></div> */}

        {/* red left + right bars */}
        <div className="absolute inset-0 flex justify-between pointer-events-none">
          <div className="flex-1 bg-black max-w-[calc((100vw-1440px)/2)]" />
          <div className="flex-1 bg-black max-w-[calc((100vw-1440px)/2)]" />
        </div>
      </div>

      <Modal open={open} onOpenChange={setOpen} title="Design inside" size="lg">
        <div className="sm:flex hidden text-black justify-center items-center w-full bg-white">
          <div className="flex-1 w-59 h-120 rounded-lg">
            <ImageSlider images={imagesData} width={236} height={480} />
          </div>
          <div className="flex flex-col justify-center items-center max-w-108.5">
            <div className="flex flex-col gap-5 justify-center items-center">
              <div className="flex flex-col gap-2 justify-center items-center">
                <Image
                  src="/svgs/freedom-logo-dark.svg"
                  alt="Freedom World Logo"
                  width={189}
                  height={60}
                />

                <div>
                  <Typography
                    variant="headersH5"
                    type="h5"
                    weight="900"
                    className={clsx('uppercase text-center px-4 font-bold! ')}
                  >
                    {t('popup_getstarted_oneplatform_title')}
                    {/* ONE PLATFORM TO */}
                  </Typography>
                  <Typography
                    variant="headersH5"
                    type="h5"
                    weight="900"
                    className={clsx('uppercase text-center px-4 font-bold! ')}
                  >
                    {t('popup_getstarted_oneplatform_title2')}
                    {/* POWER BUSINESS GROWTH */}
                  </Typography>
                </div>
                <Typography
                  variant="bodyXSmall"
                  type="h5"
                  weight="400"
                  className={clsx('text-center px-4  text-[#868898]')}
                >
                  {t('popup_getstarted_oneplatform_desc')}
                  {/* Join the growing network of partners maximizing sales and
                  customer engagement with Freedom World */}
                </Typography>
              </div>
              <div className="px-5 py-3 rounded-lg border border-[#D9D9D9] flex gap-2 justify-center items-center w-100">
                <div className="aspect-square">
                  <QRCodeGeneratorModal url={generatedUrl.clickURL} />
                </div>
                <div className="flex flex-col p-2.5 gap-3 w-62.25">
                  <Typography
                    variant="bodySmall"
                    type="h5"
                    weight="900"
                    className={clsx('uppercase text-left font-bold! ')}
                  >
                    {/* {t('modals_popup_download_download')} */}
                    {t('popup_getstarted_download_title')}
                  </Typography>
                  <Typography
                    variant="bodyXSmall"
                    type="h5"
                    weight="400"
                    className={clsx('text-left text-[#868898] self-stretch')}
                  >
                    {t('popup_getstarted_download_desc')}
                    {/* {t('modals_popup_download_desc')} */}
                  </Typography>
                </div>
              </div>
            </div>

            <MainButton
              label={t('popup_getstarted_cta')}
              icon="/svgs/up-right-arrow.svg"
              target="_blank"
              onClick={() => {
                if (window.innerWidth < 768) {
                  window.open(
                    'https://apps.apple.com/my/app/freedom-world-social-chat/id1606936073',
                    '_blank',
                  )
                } else {
                  setOpen(true)
                }
              }}
              className="bg-blue-main cursor-pointer z-1000 mt-5"
              noBorder
            />
          </div>
        </div>
        {/* Mobile */}
        <div className="sm:hidden flex-col text-black justify-center items-center w-77.25 bg-white">
          <div className="flex flex-col justify-center items-center w-77.25">
            <div className="flex flex-col gap-5 justify-center items-center">
              <div className="flex flex-col gap-2 justify-center items-center">
                <Image
                  src="/svgs/freedom-logo-dark.svg"
                  alt="Freedom World Logo"
                  width={189}
                  height={60}
                />
                <div>
                  <Typography
                    variant="headersH5"
                    type="h5"
                    weight="900"
                    className={clsx('uppercase text-center px-4  ')}
                  >
                    {t('modals_popup_download_maintitle')}
                  </Typography>
                  <Typography
                    variant="headersH5"
                    type="h5"
                    weight="900"
                    className={clsx('uppercase text-center px-4  ')}
                  >
                    {t('modals_popup_download_maintitle2')}
                  </Typography>
                </div>
                <Typography
                  variant="bodyXSmall"
                  type="h5"
                  weight="400"
                  className={clsx('text-center px-4  text-[#868898]')}
                >
                  {t('modals_popup_download_mainbody')}
                </Typography>
              </div>

              <div className="flex-1 w-77.25 h-72.5 rounded-lg">
                <ImageSlider images={imagesData} width={309} height={290} />
              </div>
            </div>
            <CustomButton
              title={t('modals_popup_download_cta_mobile')}
              typographyVariant="bodyLarge"
              circleColor="bg-blue-main"
              fontSize="text-"
              onClickUrl="https://freedomworld.onelink.me/P3wD/tap7x8lu"
              className="uppercase mt-5 mb-5"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Hiro
